module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Light.5b455543.ttf";